import Button from "../../../components/Button";
import ProgressBar from "../../../components/ProgressBar";
import AddIcon from "/public/images/icons/add.svg?react";
import { useNavigate } from "react-router-dom";
import { useDrawerContext } from "../../../context/drawerContext";
import CloseIcon from "/public/images/icons/close.svg?react";
import TextInput from "../../../components/TextInput";
import { useEffect, useState } from "react";
import MedicalCard from "../../../components/MedicalCard";
import PropTypes from "prop-types";

export default function GuestBandStep2({ band }) {
  const navigate = useNavigate();
  const { setOpen, setDrawerContent } = useDrawerContext();
  const [medicalHistory, setMedicalHistory] = useState(localStorage.getItem("activeGuestBandStep2") ? JSON.parse(localStorage.getItem("activeGuestBandStep2")) : []);

  const openMedicalDrawer = () => {
    setOpen(true);
    setDrawerContent(
      <div className="w-full">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
            Medical History
          </h2>
          <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col justify-stretch">
          <h3 className="text-[24px]">Enter your condition name</h3>
          <form onSubmit={addMedicalHistory} className="flex flex-col gap-6">
            <TextInput label={"Condition Name"} name="conditionName" defaultValue={""}/>
            <TextInput
              label="Additional Information"
              name="additionalInformation"
            />
            <Button submit>
              Confirm & Continue
            </Button>
          </form>
        </div>
      </div>
    );
  };

  const openEditDrawer = (index) => {
    setOpen(true);
    setDrawerContent(
      <div className="w-full">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
            Medical History
          </h2>
          <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col justify-stretch">
          <h3 className="text-[24px]">Edit your medical condition</h3>
          <form
            onSubmit={(e) => editMedicalHistory(e, index)}
            className="flex flex-col gap-6"
          >
            <TextInput
              key={"editCondition" + index}
              defaultValue={medicalHistory[index].name}
              label={"Condition Name"}
              name="conditionName"
            />
            <TextInput
              key={"editAdditional" + index}
              defaultValue={medicalHistory[index].additionalInformation}
              label="Additional Information"
              name="additionalInformation"
            />
            <Button submit>
              Confirm & Continue
            </Button>
          </form>
        </div>
      </div>
    );
  };

  const addMedicalHistory = (event) => {
    event.preventDefault();
    const newDetails = new FormData(event.currentTarget);

     const conditionName = newDetails.get("conditionName")?.trim();
    const additionalInformation = newDetails.get("additionalInformation")?.trim();

     if (!conditionName) {
      return;
    }

    const newMedicalDataArray = [];

    newMedicalDataArray.push({
      name: conditionName,
      additionalInformation: additionalInformation,
      dateAdded: new Date(),
      ongoing: false,
    });

    setMedicalHistory([...medicalHistory, ...newMedicalDataArray]);
    setOpen(false);
    setDrawerContent(<div></div>);
  };

  const editMedicalHistory = (event, index) => {
    event.preventDefault();

    const newMedicalHistory = medicalHistory.map((item, i) => {
      if (i === index) {
        item.name = event.currentTarget.conditionName.value;
        item.additionalInformation =
          event.currentTarget.additionalInformation.value;
      }
      return item;
    });
    setMedicalHistory(newMedicalHistory);
    setOpen(false);
  };

  const removeMedicalHistory = (index) => {
    const newMedicalHistory = medicalHistory.filter((_, i) => i !== index);
    setMedicalHistory(newMedicalHistory);
  };

  const checkOngoing = (index) => {
    const newMedicalHistory = medicalHistory.map((item, i) => {
      if (i === index) {
        item.ongoing = !item.ongoing;
      }
      return item;
    });
    setMedicalHistory(newMedicalHistory);
  };

  const validateStep3 = () => {
    localStorage.setItem("activeGuestBandStep2", JSON.stringify(medicalHistory));
    navigate(`/guest-bands/${band?.BandID}/activate/3`, {state: {band: band}});
  }

  return (
    <div className="w-full min-h-svh flex flex-col justify-stretch mb-[50px] bg-[#F8F8F8]">
      <div className="p-[24px] flex flex-col gap-1 bg-white">
        <div className="mb-6">
          <ProgressBar step={2} overrideTotalSteps={4} />
        </div>
        <span className="tracking-[0.25em] text-[12px] uppercase font-semibold">
          Step 2
        </span>
        <h2 className="mb-5">Please let us know your medical history</h2>
        <p>
          This information will be visible to venue staff and the public when your band is unlocked.
        </p>
      </div>
  
      {/* Medical History Section - Always Renders */}
      <div className={`bg-sportsLightGrey border-[#E3E3E3] border-t-[1px] p-[24px] flex justify-center flex-col gap-6 ${medicalHistory.length <= 1 ? 'pb-[250px]' : 'pb-[200px]'}`}>
        {medicalHistory.length > 0 ? (
          medicalHistory.map((item, index) => (
            <MedicalCard
              editFunc={() => openEditDrawer(index)}
              checkedFunc={() => checkOngoing(index)}
              removeFunc={() => removeMedicalHistory(index)}
              key={index}
              medication={item}
            />
          ))
        ) : (
          <p className="text-[#909090] text-center">No medical history has been provided</p>
        )}
      </div>
  
      {/* Fixed Buttons at Bottom */}
      <div className="fixed bottom-[60px] left-1/2 transform -translate-x-1/2 w-full max-w-[430px] border-t border-l border-r rounded-t-[32px] border-[#E3E3E3] bg-white p-[24px] flex flex-col justify-stretch gap-4">
        <Button className="font-semibold" onClick={openMedicalDrawer} variant="tertiary">
          <AddIcon className="w-[15px]" />
          {medicalHistory.length > 0 ? "Add Another" : "Add Medical History"}
        </Button>
        <Button onClick={validateStep3}>
          {medicalHistory.length > 0 ? "Confirm & Continue" : "Continue Without Medical History"}
        </Button>
      </div>
    </div>
  );
}